import { useAxios } from '@/composables/axios';
import type { HomeDashboardResponseType, GlobalConfigResponseType } from '@nailsupply/review-swagger/home';
import type { ApiResponse } from '@/types/models';

export const homeApis = () => {
  const { callAxios } = useAxios();

  const getHomeData = async (
  ): Promise<ApiResponse<HomeDashboardResponseType> | null> => {
    return await callAxios<ApiResponse<HomeDashboardResponseType>>({
      API: '/api/v1/home',
      method: 'GET',
    });
  };

  const getDataGlobal = async (
  ): Promise<ApiResponse<GlobalConfigResponseType> | null> => {
    return await callAxios<ApiResponse<GlobalConfigResponseType>>({
      API: '/api/v1/home/global-config',
      method: 'GET',
    });
  };

  return {
    getHomeData,
    getDataGlobal
  }
}
